import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { LzLogModule } from "../lz-log/lz-log.module";
import { TranslateModule } from "@ngx-translate/core";

import { LzUserMessagesComponent } from "./lz-user-messages.component";

import { LzUserMessagesService } from "./services/lz-user-messages.service";

@NgModule({
  declarations: [
    LzUserMessagesComponent
  ],
  providers: [
    LzUserMessagesService,
    {
      provide: MatDialogRef,
      useValue: {}
    },
    {
      provide: MAT_DIALOG_DATA,
      useValue: {}
    }
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    LzLogModule,
    TranslateModule
  ],
  entryComponents: [
    LzUserMessagesComponent
  ]
})

export class LzUserMessagesModule { }
